module.exports = __webpack_public_path__ + "static/media/game-console-handheld.901caba5.svg";